const { print } = require('graphql')

const WorldKinectEnvironment = require('../utils/environment')

const auth0Client = require('@auth0/auth0-spa-js')
const radarAuth0Config = WorldKinectEnvironment.getRadarAuth0Config()
const radarDapiUrl = WorldKinectEnvironment.getRadarDapiUrl()

function fetchData(query, variables) {
  if (WorldKinectEnvironment.isLocalhostEnvironment()) {
    return performAPIRequest(query, variables)
  } else {
    const auth0 = new auth0Client.Auth0Client(radarAuth0Config)

    return auth0.getTokenSilently().then((accessToken) => {
      return performAPIRequest(query, variables, accessToken)
    })
  }
}

function performAPIRequest(query, variables, accessToken) {
  return fetch(radarDapiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'apollographql-client-name': 'Technology Radar',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      query: print(query),
      variables: variables,
    }),
  })
}

module.exports = fetchData
